const Products = {
    LEAD: 'Lead',
    APPOINTMENT: 'Appointment'
}

export default Products;